<div class="row mb-4 mt-3">
    <div class="col-md-12 d-flex flex-row align-items-center">
      <h4 class="mb-0">
        Candidaturas
      </h4>
     
      </div>
    </div>
  
  <!-- -->
  <div class="row">
    <div class="col-md-12">
      <nav>
        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
          <a class="nav-item nav-link active" id="nav-contact-tab" data-toggle="tab" href="#nav-candidaturaSub" role="tab" aria-controls="nav-candidaturaSub" >Config. Candidatura</a>
          <a class="nav-item nav-link" id="nav-integra-tab" data-toggle="tab" href="#nav-aprovadores" role="tab" aria-controls="nav-aprovadores" >Aprovadores</a>
          <a class="nav-item nav-link" id="nav-integra-tab" data-toggle="tab" href="#nav-precandidatos" role="tab" aria-controls="nav-precandidatos" >Pré-candidatos</a>
          <a class="nav-item nav-link" id="nav-backlist2-tab" data-toggle="tab" href="#nav-blacklist2" role="tab" aria-controls="nav-contact2" >Blacklist</a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent"> 
        <div class="tab-pane fade show active pt-4" id="nav-candidaturaSub" role="tabpanel">
         <app-candidaturas></app-candidaturas>
        </div>      
        <div class="tab-pane fade" id="nav-aprovadores" role="tabpanel">
          <app-aprovador></app-aprovador>
        </div>
        <div class="tab-pane fade" id="nav-precandidatos" role="tabpanel">
            <app-precandidato></app-precandidato>
          </div>           
        <div class="tab-pane fade" id="nav-blacklist2" role="tabpanel">
          <cadastro-blacklistpre></cadastro-blacklistpre>
        </div>
      </div>
    </div>
  </div>

   


